module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_07@2x-8c2eddd76a33e728a148a713700cd839.webp";